import React, { useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import { MaterialReactTable } from "material-react-table";
import { Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import TitlePages from "../../../layout/TitlePages";
import Breadcrumbs from "../../../layout/Breadcrumbs";
import Expandible from "../../../layout/HelperDataTable/Expandible";
import { FilterComponent, useCompleteTableConfig } from "../../../constants";
import { dataAcuerdos2025 } from "../../../data/2025/dataAcuerdos";
import {
  AcuerdosDetailContainer,
  AcuerdosDetailSection,
  AcuerdosDetailRow,
} from "../../../components/acuerdos/AcuerdosDetail";

const baseUrl = "https://itetlax.org.mx/assets/pdf/acuerdos/ITE/2025/";

const PdfLink = ({ url }) => {
  const fullUrl = `${baseUrl}${url}`;
  return (
    <a href={fullUrl} target="_blank" rel="noreferrer">
      <FontAwesomeIcon icon={faFilePdf} className="btn btn-danger" />
    </a>
  );
};

const TableRow = ({ title, url }) =>
  title && url ? (
    <tr>
      <td>{title.toUpperCase()}</td>
      <td>
        <PdfLink url={url} />
      </td>
    </tr>
  ) : null;

const AcuerdosITE2025 = () => {
  useEffect(() => {
    document.title = `Acuerdos ITE 2025`;
  }, []);

  const columnsAcuerdos = useMemo(
    () => [
      {
        accessorKey: "monthDoc",
        header: "MES",
        footer: "MES",
        size: 30,
        Filter: FilterComponent,
      },
      {
        accessorFn: (row) => `ITE-CG ${row.id}-2025`,
        id: "acuerdo",
        header: "ACUERDO",
        footer: "ACUERDO",
        size: 55,
      },
      {
        accessorFn: (row) =>
          row.nameDoc ? `${row.typeDoc} ${row.nameDoc}` : "",
        id: "titulo",
        header: "TÍTULO",
        footer: "TÍTULO",
        size: 255,
      },
    ],
    []
  );

  const renderDetailPanelAcuerdos = ({ row }) => {
    const anexoTitles = Object.keys(row.original).filter(
      (key) => key.startsWith("titleAnexo") && row.original[key]
    );

    const docType = row.original.typeDoc || "ACUERDO";

    return (
      <AcuerdosDetailContainer>
        <AcuerdosDetailSection title={docType}>
          <AcuerdosDetailRow
            title={`${docType} ITE-CG ${row.original.id}-2025 ${
              row.original.nameDoc || ""
            }`}
            url={row.original.id ? `${baseUrl}${row.original.id}.pdf` : null}
            isMain={true}
          />
        </AcuerdosDetailSection>
        {anexoTitles.length > 0 && (
          <AcuerdosDetailSection title="ANEXO">
            {anexoTitles.map((key) => {
              const index = key.replace("titleAnexo", "");
              return (
                <AcuerdosDetailRow
                  key={index}
                  title={row.original[key] ? row.original[key].toUpperCase() : ""}
                  url={`${baseUrl}${row.original.id}.${index}.pdf`}
                />
              );
            })}
          </AcuerdosDetailSection>
        )}
      </AcuerdosDetailContainer>
    );
  };

  const tableAcuerdos = useCompleteTableConfig(
    dataAcuerdos2025,
    columnsAcuerdos,
    renderDetailPanelAcuerdos
  );

  return (
    <div className="margin-bottom-2">
      <Breadcrumbs path={[{ label: `Acuerdos 2025` }]} />
      <TitlePages title="Acuerdos ITE" subTitle="Acuerdos ITE 2025" />
      <Expandible />
      <MaterialReactTable table={tableAcuerdos} />
    </div>
  );
};

export default AcuerdosITE2025;

PdfLink.propTypes = {
  url: PropTypes.string.isRequired,
};

TableRow.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
